/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type {
  TransferableDocumentStore,
  TransferableDocumentStoreInterface,
} from "../TransferableDocumentStore";

const _abi = [
  {
    inputs: [
      {
        internalType: "string",
        name: "name_",
        type: "string",
      },
      {
        internalType: "string",
        name: "symbol_",
        type: "string",
      },
      {
        internalType: "address",
        name: "initAdmin",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "AccessControlBadConfirmation",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "bytes32",
        name: "neededRole",
        type: "bytes32",
      },
    ],
    name: "AccessControlUnauthorizedAccount",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "document",
        type: "bytes32",
      },
    ],
    name: "DocumentExists",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "document",
        type: "bytes32",
      },
    ],
    name: "DocumentIsRevoked",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "document",
        type: "bytes32",
      },
    ],
    name: "DocumentLocked",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "ERC721IncorrectOwner",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "ERC721InsufficientApproval",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "approver",
        type: "address",
      },
    ],
    name: "ERC721InvalidApprover",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "ERC721InvalidOperator",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "ERC721InvalidOwner",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "receiver",
        type: "address",
      },
    ],
    name: "ERC721InvalidReceiver",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "ERC721InvalidSender",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "ERC721NonexistentToken",
    type: "error",
  },
  {
    inputs: [],
    name: "EnforcedPause",
    type: "error",
  },
  {
    inputs: [],
    name: "ExpectedPause",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "document",
        type: "bytes32",
      },
    ],
    name: "InactiveDocument",
    type: "error",
  },
  {
    inputs: [],
    name: "InvalidInitialization",
    type: "error",
  },
  {
    inputs: [],
    name: "NotInitializing",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "length",
        type: "uint256",
      },
    ],
    name: "StringsInsufficientHexLength",
    type: "error",
  },
  {
    inputs: [],
    name: "ZeroDocument",
    type: "error",
  },
  {
    inputs: [],
    name: "ZeroOwner",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "approved",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "ApprovalForAll",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "document",
        type: "bytes32",
      },
    ],
    name: "DocumentIssued",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "documentRoot",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "document",
        type: "bytes32",
      },
    ],
    name: "DocumentRevoked",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint64",
        name: "version",
        type: "uint64",
      },
    ],
    name: "Initialized",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Locked",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Paused",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "previousAdminRole",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "newAdminRole",
        type: "bytes32",
      },
    ],
    name: "RoleAdminChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleGranted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleRevoked",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "Unlocked",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Unpaused",
    type: "event",
  },
  {
    inputs: [],
    name: "DEFAULT_ADMIN_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "ISSUER_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "REVOKER_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "getApproved",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleAdmin",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "grantRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "hasRole",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "document",
        type: "bytes32",
      },
    ],
    name: "isActive",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "document",
        type: "bytes32",
      },
    ],
    name: "isIssued",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "document",
        type: "bytes32",
      },
    ],
    name: "isRevoked",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "bytes32",
        name: "document",
        type: "bytes32",
      },
      {
        internalType: "bool",
        name: "lock",
        type: "bool",
      },
    ],
    name: "issue",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "locked",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "ownerOf",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "pause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "paused",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "callerConfirmation",
        type: "address",
      },
    ],
    name: "renounceRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "document",
        type: "bytes32",
      },
    ],
    name: "revoke",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "revokeRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "baseURI",
        type: "string",
      },
    ],
    name: "setBaseURI",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "tokenURI",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "unpause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
] as const;

const _bytecode =
  "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";

type TransferableDocumentStoreConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: TransferableDocumentStoreConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class TransferableDocumentStore__factory extends ContractFactory {
  constructor(...args: TransferableDocumentStoreConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    name_: string,
    symbol_: string,
    initAdmin: string,
    overrides?: Overrides & { from?: string }
  ): Promise<TransferableDocumentStore> {
    return super.deploy(
      name_,
      symbol_,
      initAdmin,
      overrides || {}
    ) as Promise<TransferableDocumentStore>;
  }
  override getDeployTransaction(
    name_: string,
    symbol_: string,
    initAdmin: string,
    overrides?: Overrides & { from?: string }
  ): TransactionRequest {
    return super.getDeployTransaction(
      name_,
      symbol_,
      initAdmin,
      overrides || {}
    );
  }
  override attach(address: string): TransferableDocumentStore {
    return super.attach(address) as TransferableDocumentStore;
  }
  override connect(signer: Signer): TransferableDocumentStore__factory {
    return super.connect(signer) as TransferableDocumentStore__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): TransferableDocumentStoreInterface {
    return new utils.Interface(_abi) as TransferableDocumentStoreInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): TransferableDocumentStore {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as TransferableDocumentStore;
  }
}
